/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DatasourceProcessedUntilTimestampResponse
 *
 */
// create custom validators for the regexes
export interface DatasourceProcessedUntilTimestampResponse {
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof DatasourceProcessedUntilTimestampResponse
        
    * @minimum 0
            
         */
    processedUntilTimestamp: number;
}
/**
 * Check if a given object implements the DatasourceProcessedUntilTimestampResponse interface.
 */
export function instanceOfDatasourceProcessedUntilTimestampResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "processedUntilTimestamp" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DatasourceProcessedUntilTimestampResponseTypiaAssertEquals = (input: any) => {
    return ((input: any): DatasourceProcessedUntilTimestampResponse => {
        const __is = (input: any, _exceptionable: boolean = true): input is DatasourceProcessedUntilTimestampResponse => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.processedUntilTimestamp && 0 <= input.processedUntilTimestamp && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["processedUntilTimestamp"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceProcessedUntilTimestampResponse => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.processedUntilTimestamp && (0 <= input.processedUntilTimestamp || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number (@minimum 0)",
                    value: input.processedUntilTimestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number",
                    value: input.processedUntilTimestamp
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["processedUntilTimestamp"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampResponse",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampResponse",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DatasourceProcessedUntilTimestampResponseTypiaAssertStringify = (input: DatasourceProcessedUntilTimestampResponse): string => {
    return ((input: any): string => { const assert = (input: any): DatasourceProcessedUntilTimestampResponse => {
        const __is = (input: any): input is DatasourceProcessedUntilTimestampResponse => {
            return "object" === typeof input && null !== input && ("number" === typeof (input as any).processedUntilTimestamp && !Number.isNaN((input as any).processedUntilTimestamp) && 0 <= (input as any).processedUntilTimestamp);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasourceProcessedUntilTimestampResponse => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => "number" === typeof input.processedUntilTimestamp && !Number.isNaN(input.processedUntilTimestamp) && (0 <= input.processedUntilTimestamp || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number (@minimum 0)",
                    value: input.processedUntilTimestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number",
                    value: input.processedUntilTimestamp
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampResponse",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampResponse",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DatasourceProcessedUntilTimestampResponse): string => {
        return `{"processedUntilTimestamp":${(input as any).processedUntilTimestamp}}`;
    }; return stringify(assert(input)); })(input);
};
export const DatasourceProcessedUntilTimestampResponseValidatorShape = {
    'processedUntilTimestamp': yup.number().min(0).defined(),
};
export const DatasourceProcessedUntilTimestampResponseValidator = yup.object().shape(DatasourceProcessedUntilTimestampResponseValidatorShape);
export const DatasourceProcessedUntilTimestampResponseStringifyShapeProperties: ObjectSchema['properties'] = {
    'processedUntilTimestamp': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
};
export const DatasourceProcessedUntilTimestampResponseStringifyShape: ObjectSchema = {
    title: 'DatasourceProcessedUntilTimestampResponse Stringifier',
    type: 'object',
    properties: {
        ...DatasourceProcessedUntilTimestampResponseStringifyShapeProperties
    },
    required: [
        'processedUntilTimestamp',
    ],
};
export const DatasourceProcessedUntilTimestampResponseStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasourceProcessedUntilTimestampResponseStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DatasourceProcessedUntilTimestampResponseStringify: (data: DatasourceProcessedUntilTimestampResponse) => string = DatasourceProcessedUntilTimestampResponseStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DatasourceProcessedUntilTimestampResponseFromJSON(json: any): DatasourceProcessedUntilTimestampResponse {
    return DatasourceProcessedUntilTimestampResponseFromJSONTyped(json, false);
}
export function DatasourceProcessedUntilTimestampResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasourceProcessedUntilTimestampResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'processedUntilTimestamp': json['processedUntilTimestamp'],
    };
}
export function DatasourceProcessedUntilTimestampResponseToJSON(value?: DatasourceProcessedUntilTimestampResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'processedUntilTimestamp': value.processedUntilTimestamp,
    };
}
